import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Nav, MobileNav, Header } from './layout';
import { withRouter } from 'react-router-dom';
import { LegalSection } from "./common";
import { connect } from 'react-redux';
import { features, featureHelpers } from './features';
import { integrationTypes, tenantHelpers } from './tenantInfo';
import './App.scss';

/** This component displays the basic layout for the Application (header, navbar, and optionally privacy links) */
class AppContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: 0,
      height: 0,
    }

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  handleRouteChange(params) {
    const { location } = params;
    const { state } = location || {};
    const { focusElement } = state || {};
    const element = document.getElementById(focusElement ? focusElement : "view");
    element && element.focus();

    const intercomApplicationId = process.env.INTERCOM_APPLICATION_ID;
    const { Intercom } = window;
    const useIntercom = (intercomApplicationId && Intercom);
    if (useIntercom) {
      Intercom('update');
    }
    window.scrollTo(0, 0);
  }

  componentWillMount() {
    this.handleRouteChange(this.props);
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateWindowDimensions);
    this.updateWindowDimensions();
  }

  componentDidUpdate(prevProps) {
    const { location : prevLocation } = prevProps;
    const { location : currentLocation } = this.props;
    if(currentLocation.pathname !== prevLocation.pathname) {
      this.handleRouteChange(this.props);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    const { layout, hidePrivacyLinks, routes } = this.props;
    const { desktopNavCollapsed } = layout;
    var appClass = "no-focus";
    const companyName = tenantHelpers.getCompanyName();

    if(
      (!featureHelpers.featureEnabled(features.apricotPortalTier2) &&
      tenantHelpers.getIntegrationType() === integrationTypes.apricot) ||
      desktopNavCollapsed
      ) {
      appClass += " app-hide-nav";
    }

    return (
      <div className="ssg-forms-scrollable app-page">
        <Header />
        {this.state.width < 768 ? <MobileNav />: <Nav />}
        <div id="view" className={appClass}>
          <div className="app-route-content">
            {routes}
          </div>
          {hidePrivacyLinks ? null : (
            <div className="app-legal-section">
              <LegalSection/>
              <div className="app-legal-section-logo">
                <bonterra-logo name="bonterra_logo_horizontal" size="medium" />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

AppContent.propTypes = {
  /** This JSX.Element should contain the routes that represent the content of the page */
  routes: PropTypes.any.isRequired,
  /** if true the privacy links section will not be displayed */
  hidePrivacyLinks: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ layout }) => {
  return {
    layout,
  }
}

export default connect(mapStateToProps)(withRouter(AppContent));



// WEBPACK FOOTER //
// src/app-content.js